<template>
  <div class="">
    <div class="block">
      <el-button @click="handleBack">{{ $t('back') }}</el-button>
    </div>
    <org-info :orgId="$route.query.orgId"></org-info>

    <software-situation :orgId="$route.query.orgId"></software-situation>
    <div class="block">
      <el-descriptions
        class="margin-top"
        :title="$t('whitelist.whitelistInfoTitle')"
        :column="3"
        :size="size"
        border
        :labelStyle="{ width: '217px' }"
      >
        <el-descriptions-item span="3">
          <template slot="label">
            {{ $t('whitelist.whitelistInfo.terminalDimension') }}
          </template>
          <div
            v-html="
              $t('whitelist.whitelistInfo.terminalDesc', {
                total: `<span class='bold'> ${whitelistInfo.terminalTotalCount} </span>`,
                open: `<span class='green-color'> ${whitelistInfo.whiteListTerminalCount} </span>`,
                per: `<span class='green-color'> ${(whitelistInfo.whiteListTerminalPercent * 100).toFixed(2)}% </span>`
              })
            "
          ></div>
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label">
            {{ $t('whitelist.whitelistInfo.terminalGroupMension') }}
          </template>
          <div
            v-html="
              $t('whitelist.whitelistInfo.terminalGroupDesc', {
                total: `<span class='bold'> ${whitelistInfo.terminalGroupTotalCount} </span>`,
                open: `<span class='green-color'> ${whitelistInfo.whiteListTerminalGroupCount} </span>`,
                per: `<span class='green-color'> ${
                  whitelistInfo.terminalGroupTotalCount
                    ? (
                        (whitelistInfo.whiteListTerminalGroupCount / whitelistInfo.terminalGroupTotalCount) *
                        100
                      ).toFixed(2)
                    : 0
                }% </span>`
              })
            "
          ></div>
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label">
            {{ $t('whitelist.whitelistInfo.noAllowInstallSituation') }}
          </template>
          <div
            v-html="
              $t('whitelist.whitelistInfo.noAllowInstallDesc', {
                total: `<span class='bold'> ${whitelistInfo.haveWhiteListTerminalGroupCount} </span>`,
                notAllow: `<span class='bold'> ${whitelistInfo.noAllowGreenTerminalGroupCount} </span>`
              })
            "
          ></div>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t('whitelist.whitelistInfo.timeSituation') }}
          </template>
          <div
            v-html="
              $t('whitelist.whitelistInfo.timeDesc', {
                firstTime: `<span class='bold'> ${
                  whitelistInfo.whiteListFirstTime
                    ? date.format(whitelistInfo.whiteListFirstTime, 'yyyy-MM-dd HH:mm:ss')
                    : ''
                } </span>`,
                lastTime: `<span class='bold'> ${
                  whitelistInfo.whiteListLastTime
                    ? date.format(whitelistInfo.whiteListLastTime, 'yyyy-MM-dd HH:mm:ss')
                    : ''
                } </span>`
              })
            "
          ></div>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="block no-data" v-if="!hasApplyModal">
      <el-descriptions
        class="margin-top"
        :title="$t('whitelist.whiteListGlobalConfigTitle')"
        :column="3"
        :size="size"
        :labelStyle="{ width: '0px', backgroud: '#fff' }"
        border
        ><el-descriptions-item>无</el-descriptions-item></el-descriptions
      >
    </div>
    <div class="block" v-else>
      <el-descriptions
        class="margin-top"
        :title="$t('whitelist.whiteListGlobalConfigTitle')"
        :column="3"
        :size="size"
        :labelStyle="{ width: '217px' }"
        border
      >
        <el-descriptions-item span="3" v-if="whiteListGlobalConfig && !whiteListGlobalConfig.open">
          <template slot="label">
            <i class="el-icon-user-solid"></i>
            {{ $t('whitelist.softControl') }}
          </template>
          {{ whiteListGlobalConfig && whiteListGlobalConfig.open ? $t('whitelist.open') : $t('whitelist.close') }}
        </el-descriptions-item>
        <el-descriptions-item v-if="whiteListGlobalConfig && whiteListGlobalConfig.open">
          <template slot="label">
            <i class="el-icon-user-solid"></i>
            {{ $t('whitelist.whiteListGlobalConfig.allowGreen') }}
          </template>
          {{ whiteListGlobalConfig && whiteListGlobalConfig.allowGreen ? $t('whitelist.yes') : $t('whitelist.no') }}
        </el-descriptions-item>
        <el-descriptions-item v-if="whiteListGlobalConfig && whiteListGlobalConfig.open">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            {{ $t('whitelist.whiteListGlobalConfig.whitelistSoftware') }}
          </template>
          <div class="sky-hc-software-list__tags">
            <el-tag
              class="sky-hc-software-list__tag-item"
              v-for="(item, index) in whiteListGlobalConfig.whiteListSoftware"
              v-bind:key="index"
              type="success"
              :class="{ 'sky-hc-software-list__tag-item--uninstall': item.isUninstall }"
              >{{ item.label }}</el-tag
            >
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="sky-hc-software-list__box">
      <div class="block sky-hc-software-list__box--l">
        <p class="el-descriptions__title">{{ $t('whitelist.whiteOperation') }}</p>
        <!-- <el-pagination
         @prev-click="handlePrevClick"    
         @next-click="handleNextClick"
         @size-change="handleSizeChange"
         :data="behaviorList"
        :page="page"
        :page-sizes="[20, 40, 60, 80]"
        :limit="terminalLimit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count">
      </el-pagination> -->
        <el-timeline class="sky-hc__time-line">
          <el-timeline-item
            v-for="behavior in behaviorList"
            :key="behavior.id"
            :timestamp="date.format(behavior.createTime, 'yyyy-MM-dd HH:mm:ss')"
            placement="top"
          >
            <h4>{{ behavior.title }}</h4>
            <p>{{ behavior.description }}</p>
          </el-timeline-item>
        </el-timeline>
        <div class="sky-hc-software-list__btn-wrapper" v-if="showBehaviorMore">
          <el-button class="sky-hc-software-list__btn-more" :disabled="behaviorLoading" @click="loadMoreBehavior">{{
            $t('whitelist.loadMore')
          }}</el-button>
        </div>
        <div v-if="behaviorList.length === 0" class="sky-hc-software-list__no-data">{{ $t('whitelist.noData') }}</div>
      </div>
      <div class="block sky-hc-software-list__box--r">
        <p class="el-descriptions__title">{{ $t('whitelist.terminalWhiteListDtl') }}</p>
        <!-- <el-pagination
         @prev-click="handleTerminalPrevClick"    
         @next-click="handleTerminalNextClick"
         @size-change="handleTerminalSizeChange"
         :data="terminalBehaviorList"
        :page="terminalPage"
        :page-sizes="[20, 40, 60, 80]"
        :limit="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="terminalCount">
      </el-pagination> -->
        <el-timeline class="sky-hc__time-line">
          <el-timeline-item
            v-for="behavior in terminalBehaviorList"
            :key="behavior.id"
            :timestamp="date.format(behavior.time, 'yyyy-MM-dd HH:mm:ss')"
            placement="top"
          >
            <p class="">{{ getTerminalSoftDesc(behavior) }}</p>
          </el-timeline-item>
        </el-timeline>
        <div class="sky-hc-software-list__btn-wrapper" v-if="showTerminalBehaviorMore">
          <el-button
            class="sky-hc-software-list__btn-more"
            :disabled="terminalBehaviorLoading"
            @click="loadMoreTerminalBehavior"
            >{{ $t('whitelist.loadMore') }}</el-button
          >
        </div>
        <div v-if="terminalBehaviorList.length === 0" class="sky-hc-software-list__no-data">
          {{ $t('whitelist.noData') }}
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import { Card, Pagination, Tag, Button } from 'element-ui'

import date from 'element-ui/lib/utils/date'

import OrgInfo from './components/orgInfo'
import SoftwareSituation from './components/softwareSituation'

import { getBehaviorList, getWhiteListGlobalConfig, getTerminalSoftDtl, getWhitelistInfo } from '@/api/whitelist'

import { SOFT_STOP_TYPE } from '@/utils/enum'

import Backtop from '@/views/components/backtop'
import descriptions from '@/views/components/descriptions'
import descriptionsItem from '@/views/components/descriptions-item'
import timeline from '@/views/components/timeline'
import timelineItem from '@/views/components/timeline-item'

export default {
  name: 'whitelistDetail',
  components: {
    elTimeline: timeline,
    elTimelineItem: timelineItem,
    elDescriptions: descriptions,
    elDescriptionsItem: descriptionsItem,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    [Backtop.name]: Backtop,
    OrgInfo,
    SoftwareSituation
  },
  data() {
    return {
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      behaviorList: [],
      // orgInfo: {},
      whitelistInfo: {},
      whiteListGlobalConfig: {},
      date,
      size: '1',
      openButNoSoft: false,
      softwareList: [],
      whiteList: [],
      uninstallNum: 0,
      hasApplyModal: false,
      terminalCount: 0,
      terminalPage: 0,
      terminalBehaviorList: [],
      terminalLimit: 20,
      behaviorLoading: false,
      terminalBehaviorLoading: false
    }
  },
  created() {
    this.handleGetWhitelistInfo()

    this.handleGetBehaviorList()
    this.handleGetWhiteListGlobalConfig()
    this.handleGetTerminalSoftDtl()
  },
  computed: {
    showBehaviorMore() {
      return this.behaviorList.length < this.count
    },
    showTerminalBehaviorMore() {
      return this.terminalBehaviorList.length < this.terminalCount
    }
  },
  methods: {
    handlePrevClick() {
      ///
      this.page--
      this.handleGetBehaviorList()
    },
    handleNextClick() {
      this.page++
      this.handleGetBehaviorList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetBehaviorList()
    },
    handleTerminalPrevClick() {
      ///
      this.terminalPage--
      this.handleGetTerminalSoftDtl()
    },
    handleTerminalNextClick() {
      this.terminalPage++
      this.handleGetTerminalSoftDtl()
    },
    handleTerminalSizeChange(num) {
      this.terminalLimit = num
      this.terminalPage = 0
      this.handleGetTerminalSoftDtl()
    },
    handleGetBehaviorList() {
      if (this.behaviorLoading) {
        return
      }
      this.behaviorLoading = true
      getBehaviorList({
        page: this.page,
        limit: this.limit,
        searchKeyword: this.keyword,
        type: this.softwareType,
        orgId: this.$route.query.orgId
      }).then(response => {
        this.behaviorList = this.behaviorList.concat(response.data.content.itemArr)
        this.count = response.data.content.total
        this.behaviorLoading = false
      })
    },
    handleGetTerminalSoftDtl() {
      if (this.terminalBehaviorLoading) {
        return
      }
      this.terminalBehaviorLoading = true
      getTerminalSoftDtl({
        page: this.page,
        limit: this.limit,
        type: this.softwareType,
        orgId: this.$route.query.orgId
      }).then(response => {
        this.terminalBehaviorList = this.terminalBehaviorList.concat(response.data.content.itemArr)
        this.terminalCount = response.data.content.total
        this.terminalBehaviorLoading = false
      })
    },
    handleGetWhitelistInfo() {
      getWhitelistInfo({
        id: this.$route.query.orgId
      }).then(response => {
        this.whitelistInfo = response.data.content
      })
    },
    handleGetWhiteListGlobalConfig() {
      getWhiteListGlobalConfig({
        id: this.$route.query.orgId
      }).then(response => {
        const data = response.data.content
        if (!data) {
          this.hasApplyModal = false
          return
        }
        this.hasApplyModal = true
        let whitelistSoftware = [...data.whiteListSoftware]
        let totalSoftware = [...data.totalSoftware]
        let resSoftwareArr = []
        let num = 0
        whitelistSoftware.map(item => {
          if (totalSoftware.length > 0) {
            const index = totalSoftware.indexOf(item)
            if (index > -1) {
              resSoftwareArr.splice(num, 0, {
                label: item,
                isWhitelist: true,
                isUninstall: false
              })
              num++
            } else {
              resSoftwareArr.push({
                label: item,
                isWhitelist: true,
                isUninstall: true
              })
            }
          } else {
            resSoftwareArr.push({
              label: item,
              isWhitelist: false,
              isUninstall: true
            })
          }
        })
        Object.assign(this.whiteListGlobalConfig, {
          whiteListSoftware: resSoftwareArr,
          allowGreen: data.allowGreen,
          open: data.open
        })
      })
    },
    handleBack() {
      this.$router.back()
      // if (this.$route.params.isFromActiveOrg) {
      //   this.$router.push({
      //     name: 'activeOrganizationDetail',
      //     query: {
      //       orgId: this.$route.query.orgId
      //     }
      //   })
      // } else {
      //   this.$router.push('/function-analysis/whitelist-manage/whitelist')
      // }
    },
    getTerminalSoftDesc(behavior) {
      if (behavior.type === SOFT_STOP_TYPE.SOFT) {
        return (
          `【${behavior.groupName ? behavior.groupName : '--'}】分组下的【${
            behavior.terminalName ? behavior.terminalName : '--'
          }】终端，` + this.$t('whitelist.stopRun', { name: behavior.softwareName })
        )
      } else if (behavior.type === SOFT_STOP_TYPE.PACKAGE) {
        return (
          `【${behavior.groupName ? behavior.groupName : '--'}】分组下的【${
            behavior.terminalName ? behavior.terminalName : '--'
          }】终端，` + this.$t('whitelist.stopInstall', { name: behavior.softwareName })
        )
      }
      return ''
    },
    loadMoreBehavior() {
      this.page++
      this.handleGetBehaviorList()
    },
    loadMoreTerminalBehavior() {
      this.terminalPage++
      this.handleGetTerminalSoftDtl()
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-software-list) {
  @include e(tags) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  @include e(tag-item) {
    margin-right: 10px;
    margin-bottom: 6px;
    @include m(uninstall) {
      opacity: 0.3;
    }
  }
  @include e(desc) {
    font-weight: normal;
  }
  @include e(box) {
    display: flex;
    justify-content: space-between;
    @include m(l) {
      flex: 1;
    }
    @include m(r) {
      flex: 1;
      padding-left: 30px;
    }
  }
  @include e(btn-wrapper) {
  }
  @include e(btn-more) {
    margin-left: 166px;
  }
  @include e(no-data) {
    font-size: 14px;
    color: $--color-grey-6;
  }
}
.block {
  margin: 15px;
}
.el-tag--grey {
  background-color: #f4f4f5 !important;
  border-color: #e9e9eb !important;
  color: #909399 !important;
}
.bold {
  font-weight: bold;
  font-size: 16px;
}
.uninstall-color {
  color: $--color-success;
  font-weight: bold;
  font-size: 16px;
  opacity: 0.3;
}
.link-color {
  color: $--color-primary;
  font-weight: bold;
  font-size: 16px;
}
.green-color {
  color: $--color-success;
  font-weight: bold;
  font-size: 16px;
}
.bold--big,
.green-color--big {
  font-size: 18px;
}
.no-data {
  text-align: center;
  line-height: 40px;
  .is-bordered-label {
    display: none;
  }
  .el-descriptions-item__content {
    text-align: center !important;
  }
}
</style>
